import { axios } from '@/utils/http'
import { ExamRoomRecord } from '@/models/exam/record'

export async function get(examId: string): Promise<ExamRoomRecord[]>
export async function get(
  examId: string,
  roomId: string
): Promise<ExamRoomRecord>
export async function get(examId: string, roomId?: string) {
  const url = roomId
    ? `exam/${examId}/room/${roomId}/record`
    : `exam/${examId}/room/record`
  const { data } = await axios.get(url)
  return data
}
